var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useState, useRef, useEffect } from "react";
import { Box, Typography, TextField, IconButton, CircularProgress, Slide, Button, } from "@mui/material";
import SendIcon from "@mui/icons-material/Send";
import CloseIcon from "@mui/icons-material/Close";
import AutoGraphIcon from "@mui/icons-material/AutoGraph";
import { fetchChartData, isFixedQuery, normalizeQuery, ASSISTANT_MENU_THEMES, } from "../../services/api/ChatService";
import { useSessionStorage } from "../../hooks/Session";
import { getChartDataset, parseNumericValue, resolveLabelAndValueKeys, } from "../../utils/chartData";
var ALLOW_FREE_TEXT_ASSISTANT_REQUESTS = false;
var MENU_ONLY_GUIDANCE_MESSAGE = "No momento, este assistente funciona apenas com as opções do menu. Clique em uma opção exibida ou digite o número correspondente.";
var getThemeById = function (themeId) {
    return ASSISTANT_MENU_THEMES.find(function (theme) { return theme.id === themeId; });
};
var getThemeDisplayTitle = function (themeId) {
    var theme = getThemeById(themeId);
    return theme
        ? "Gr\u00E1fico sobre ".concat(theme.label.toLowerCase())
        : "Gráfico personalizado";
};
var getThemeByQuery = function (query) {
    return ASSISTANT_MENU_THEMES.find(function (theme) {
        return theme.options.some(function (option) { return normalizeQuery(option.query) === normalizeQuery(query); });
    });
};
var inferThemeFromText = function (question) {
    var normalizedQuestion = normalizeQuery(question);
    if (normalizedQuestion.includes("vitima") ||
        normalizedQuestion.includes("genero") ||
        normalizedQuestion.includes("idade") ||
        normalizedQuestion.includes("deficiencia")) {
        return "vitimas";
    }
    if (normalizedQuestion.includes("ocorrencia") ||
        normalizedQuestion.includes("violencia") ||
        normalizedQuestion.includes("municip")) {
        return "ocorrencias";
    }
    if (normalizedQuestion.includes("denuncia") ||
        normalizedQuestion.includes("canal") ||
        normalizedQuestion.includes("origem")) {
        return "denuncias";
    }
    return null;
};
var resolveChartTitle = function (question, themeId) {
    var _a;
    var normalizedQuestion = normalizeQuery(question);
    if (isFixedQuery(question)) {
        return question;
    }
    var resolvedThemeId = themeId !== null && themeId !== void 0 ? themeId : inferThemeFromText(question);
    if (resolvedThemeId) {
        var theme = getThemeById(resolvedThemeId);
        if ((theme === null || theme === void 0 ? void 0 : theme.id) === "vitimas") {
            if (normalizedQuestion.includes("faixa etaria") ||
                normalizedQuestion.includes("etaria") ||
                normalizedQuestion.includes("idade")) {
                return "Distribuição etária das vítimas";
            }
            if (normalizedQuestion.includes("deficiencia")) {
                return "Presença de deficiência entre as vítimas";
            }
            if (normalizedQuestion.includes("genero")) {
                return "Distribuição por gênero das vítimas";
            }
        }
        return ((_a = theme === null || theme === void 0 ? void 0 : theme.options[0]) === null || _a === void 0 ? void 0 : _a.label) || getThemeDisplayTitle(resolvedThemeId);
    }
    return "Gráfico personalizado";
};
var getMenuOptions = function (menuState) {
    if (menuState.kind === "root") {
        return ASSISTANT_MENU_THEMES.map(function (theme) { return ({
            label: theme.label,
            action: { type: "theme", themeId: theme.id },
        }); });
    }
    if (menuState.kind === "theme") {
        var theme_1 = getThemeById(menuState.themeId);
        if (!theme_1)
            return [];
        return __spreadArray(__spreadArray([], theme_1.options.map(function (option) { return ({
            label: option.label,
            action: {
                type: "query",
                query: option.query,
                themeId: theme_1.id,
            },
        }); }), true), [
            {
                label: "Voltar aos temas",
                action: { type: "root" },
            },
        ], false);
    }
    var theme = getThemeById(menuState.themeId);
    if (!theme)
        return [];
    return [
        {
            label: "Criar outro deste tema",
            action: { type: "theme", themeId: theme.id },
        },
        {
            label: "Ver outros temas",
            action: { type: "root" },
        },
    ];
};
var getMenuDescription = function (menuState) {
    if (menuState.kind === "root") {
        return "Escolha um tema para continuar. Você pode clicar em uma opção ou digitar o número correspondente.";
    }
    if (menuState.kind === "theme") {
        var theme = getThemeById(menuState.themeId);
        return theme
            ? "Escolha uma op\u00E7\u00E3o sobre ".concat(theme.label.toLowerCase(), ".")
            : "Escolha uma das opções disponíveis.";
    }
    return 'O gráfico foi adicionado à aba "Meus Gráficos". O que deseja fazer agora?';
};
var resolveMenuSelection = function (question, options) {
    var _a, _b;
    var trimmedQuestion = question.trim();
    var normalizedQuestion = normalizeQuery(trimmedQuestion);
    if (/^\d+$/.test(trimmedQuestion)) {
        var optionIndex = Number(trimmedQuestion) - 1;
        return (_a = options[optionIndex]) !== null && _a !== void 0 ? _a : null;
    }
    return ((_b = options.find(function (option) { return normalizeQuery(option.label) === normalizedQuestion; })) !== null && _b !== void 0 ? _b : null);
};
var AssistentePainel = function (_a) {
    var onChartGenerated = _a.onChartGenerated;
    var _b = useState(false), isOpen = _b[0], setIsOpen = _b[1];
    var _c = useState([]), messages = _c[0], setMessages = _c[1];
    var _d = useState(""), input = _d[0], setInput = _d[1];
    var _e = useState(false), isLoading = _e[0], setIsLoading = _e[1];
    var _f = useState(false), isHydrated = _f[0], setIsHydrated = _f[1];
    var _g = useState({ kind: "root" }), menuState = _g[0], setMenuState = _g[1];
    var chatSessionRef = useRef(useSessionStorage("chat_messages"));
    var chatSession = chatSessionRef.current;
    var messagesEndRef = useRef(null);
    var inputRef = useRef(null);
    useEffect(function () {
        var stored = chatSession.get();
        if (stored && Array.isArray(stored)) {
            setMessages(stored.map(function (msg) { return (__assign(__assign({}, msg), { timestamp: new Date(msg.timestamp) })); }));
        }
        setIsHydrated(true);
    }, [chatSession]);
    useEffect(function () {
        if (!isHydrated)
            return;
        chatSession.set(messages);
    }, [messages, isHydrated, chatSession]);
    useEffect(function () {
        var _a, _b;
        if (isOpen) {
            (_b = (_a = messagesEndRef.current) === null || _a === void 0 ? void 0 : _a.scrollIntoView) === null || _b === void 0 ? void 0 : _b.call(_a, { behavior: "smooth" });
        }
    }, [messages, isLoading, isOpen, menuState]);
    var appendAssistantMessage = function (content, options) {
        setMessages(function (prev) { return __spreadArray(__spreadArray([], prev, true), [
            {
                id: (Date.now() + 1).toString(),
                role: "assistant",
                content: content,
                chartTitle: options === null || options === void 0 ? void 0 : options.chartTitle,
                timestamp: new Date(),
                isError: options === null || options === void 0 ? void 0 : options.isError,
            },
        ], false); });
    };
    var isResponseReliable = function (data) {
        var dataset = getChartDataset(data);
        if (!dataset.length)
            return false;
        var valueKey = resolveLabelAndValueKeys(data, dataset).valueKey;
        return dataset.some(function (item) { var _a; return Number.isFinite(parseNumericValue((_a = item[valueKey]) !== null && _a !== void 0 ? _a : item.value)); });
    };
    var submitChartRequest = function (question, themeId) { return __awaiter(void 0, void 0, void 0, function () {
        var response, resolvedChartTitle, generationResult, resolvedThemeId, duplicateMessage, limitMessage, error_1, fallbackThemeId;
        var _a, _b, _c, _d, _e;
        return __generator(this, function (_f) {
            switch (_f.label) {
                case 0:
                    setIsLoading(true);
                    _f.label = 1;
                case 1:
                    _f.trys.push([1, 3, 4, 5]);
                    return [4 /*yield*/, fetchChartData(question)];
                case 2:
                    response = _f.sent();
                    if (!isResponseReliable(response.data)) {
                        throw new Error("Não encontrei dados suficientes para exibir esse gráfico.");
                    }
                    resolvedChartTitle = resolveChartTitle(question, themeId);
                    generationResult = onChartGenerated({
                        title: resolvedChartTitle,
                        data: response.data,
                        query: question,
                        normalizedQuery: normalizeQuery(question),
                    });
                    resolvedThemeId = (_c = (_b = themeId !== null && themeId !== void 0 ? themeId : (_a = getThemeByQuery(question)) === null || _a === void 0 ? void 0 : _a.id) !== null && _b !== void 0 ? _b : inferThemeFromText(question)) !== null && _c !== void 0 ? _c : "vitimas";
                    if (!generationResult.accepted) {
                        duplicateMessage = 'Esse gráfico já está disponível na aba "Meus Gráficos". Escolha outra opção deste tema ou volte para os demais temas.';
                        limitMessage = 'Você atingiu o limite de 6 gráficos personalizados nesta sessão. Remova um gráfico da aba "Meus Gráficos" para continuar.';
                        appendAssistantMessage(generationResult.reason === "duplicate"
                            ? duplicateMessage
                            : limitMessage, { isError: true });
                        setMenuState({ kind: "theme", themeId: resolvedThemeId });
                        return [2 /*return*/];
                    }
                    appendAssistantMessage("Perfeito! Criei o gr\u00E1fico \"".concat(resolvedChartTitle, "\" e ele foi adicionado \u00E0 aba \"Meus Gr\u00E1ficos\"."), { chartTitle: resolvedChartTitle });
                    setMenuState({ kind: "postSuccess", themeId: resolvedThemeId });
                    return [3 /*break*/, 5];
                case 3:
                    error_1 = _f.sent();
                    fallbackThemeId = (_e = themeId !== null && themeId !== void 0 ? themeId : (_d = getThemeByQuery(question)) === null || _d === void 0 ? void 0 : _d.id) !== null && _e !== void 0 ? _e : inferThemeFromText(question);
                    appendAssistantMessage(error_1 instanceof Error && error_1.message
                        ? error_1.message
                        : "Não consegui criar esse gráfico agora. Tente reformular o pedido ou escolha uma das opções sugeridas.", { isError: true });
                    setMenuState(fallbackThemeId
                        ? { kind: "theme", themeId: fallbackThemeId }
                        : { kind: "root" });
                    return [3 /*break*/, 5];
                case 4:
                    setIsLoading(false);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    var handleMenuAction = function (action) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (action.type === "theme") {
                        setMenuState({ kind: "theme", themeId: action.themeId });
                        return [2 /*return*/];
                    }
                    if (action.type === "root") {
                        setMenuState({ kind: "root" });
                        return [2 /*return*/];
                    }
                    return [4 /*yield*/, submitChartRequest(action.query, action.themeId)];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    var handleSend = function (text) { return __awaiter(void 0, void 0, void 0, function () {
        var question, menuOptions, selectedMenuOption;
        var _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    question = (text || input).trim();
                    if (!question || isLoading)
                        return [2 /*return*/];
                    setMessages(function (prev) { return __spreadArray(__spreadArray([], prev, true), [
                        {
                            id: Date.now().toString(),
                            role: "user",
                            content: question,
                            timestamp: new Date(),
                        },
                    ], false); });
                    setInput("");
                    menuOptions = getMenuOptions(menuState);
                    selectedMenuOption = resolveMenuSelection(question, menuOptions);
                    if (!selectedMenuOption) return [3 /*break*/, 2];
                    return [4 /*yield*/, handleMenuAction(selectedMenuOption.action)];
                case 1:
                    _c.sent();
                    return [2 /*return*/];
                case 2:
                    if (!ALLOW_FREE_TEXT_ASSISTANT_REQUESTS) {
                        appendAssistantMessage(MENU_ONLY_GUIDANCE_MESSAGE, { isError: true });
                        return [2 /*return*/];
                    }
                    if (!isFixedQuery(question)) return [3 /*break*/, 4];
                    return [4 /*yield*/, submitChartRequest(question, (_a = getThemeByQuery(question)) === null || _a === void 0 ? void 0 : _a.id)];
                case 3:
                    _c.sent();
                    return [2 /*return*/];
                case 4: return [4 /*yield*/, submitChartRequest(question, (_b = inferThemeFromText(question)) !== null && _b !== void 0 ? _b : undefined)];
                case 5:
                    _c.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    var formatContent = function (content) {
        return content
            .split(/(\*\*[^*]+\*\*)/g)
            .map(function (part, index) {
            return part.startsWith("**") && part.endsWith("**") ? (_jsx("strong", { children: part.slice(2, -2) }, index)) : (_jsx(React.Fragment, { children: part }, index));
        });
    };
    var showWelcome = messages.length === 0;
    var menuOptions = getMenuOptions(menuState);
    return (_jsxs(_Fragment, { children: [!isOpen && (_jsx(Button, __assign({ onClick: function () { return setIsOpen(true); }, variant: "contained", startIcon: _jsx(AutoGraphIcon, {}), sx: {
                    position: "fixed",
                    bottom: 24,
                    right: 24,
                    zIndex: 1200,
                    borderRadius: "28px",
                    textTransform: "none",
                    fontFamily: "Montserrat, sans-serif",
                    fontWeight: 700,
                    fontSize: "0.9rem",
                    px: 3,
                    py: 1.5,
                    background: "#034EA2",
                    boxShadow: "0 4px 20px rgba(3, 78, 162, 0.4)",
                    "&:hover": {
                        background: "#023B7A",
                        boxShadow: "0 6px 24px rgba(3, 78, 162, 0.5)",
                    },
                } }, { children: "Assistente IA" }))), _jsx(Slide, __assign({ direction: "left", in: isOpen, mountOnEnter: true, unmountOnExit: true }, { children: _jsxs(Box, __assign({ sx: {
                        position: "fixed",
                        bottom: 0,
                        right: 0,
                        width: { xs: "100vw", sm: 400 },
                        height: "50vh",
                        zIndex: 1300,
                        display: "flex",
                        flexDirection: "column",
                        boxShadow: "-4px 0 24px rgba(0,0,0,0.12)",
                        background: "#fff",
                        borderRadius: "16px 0 0 0",
                    } }, { children: [_jsxs(Box, __assign({ sx: {
                                background: "linear-gradient(135deg, #034EA2 0%, #1171CC 100%)",
                                px: 2.5,
                                py: 2,
                                display: "flex",
                                alignItems: "center",
                                gap: 1.5,
                                flexShrink: 0,
                            } }, { children: [_jsx(Box, __assign({ sx: {
                                        width: 38,
                                        height: 38,
                                        borderRadius: "10px",
                                        background: "rgba(255,255,255,0.18)",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        flexShrink: 0,
                                    } }, { children: _jsx(AutoGraphIcon, { sx: { color: "#fff", fontSize: 22 } }) })), _jsxs(Box, __assign({ sx: { flex: 1 } }, { children: [_jsx(Typography, __assign({ sx: {
                                                color: "#fff",
                                                fontFamily: "Montserrat, sans-serif",
                                                fontWeight: 700,
                                                fontSize: "0.95rem",
                                                lineHeight: 1.2,
                                            } }, { children: "Assistente de An\u00E1lise" })), _jsx(Typography, __assign({ sx: {
                                                color: "rgba(255,255,255,0.75)",
                                                fontFamily: "Montserrat, sans-serif",
                                                fontWeight: 400,
                                                fontSize: "0.72rem",
                                            } }, { children: "Crie gr\u00E1ficos personalizados" }))] })), _jsx(IconButton, __assign({ onClick: function () { return setIsOpen(false); }, size: "small", sx: { color: "#fff", opacity: 0.8, "&:hover": { opacity: 1 } } }, { children: _jsx(CloseIcon, { fontSize: "small" }) }))] })), _jsxs(Box, __assign({ sx: {
                                flex: 1,
                                overflowY: "auto",
                                px: 2,
                                py: 2,
                                display: "flex",
                                flexDirection: "column",
                                gap: 1.5,
                                background: "#F8FAFC",
                                "&::-webkit-scrollbar": { width: 4 },
                                "&::-webkit-scrollbar-thumb": {
                                    background: "#D1D5DB",
                                    borderRadius: 2,
                                },
                            } }, { children: [showWelcome && (_jsxs(Box, __assign({ sx: {
                                        background: "#fff",
                                        borderRadius: "14px",
                                        border: "1px solid #ECEEF4",
                                        p: 2,
                                        mb: 1,
                                    } }, { children: [_jsx(Typography, __assign({ sx: {
                                                fontFamily: "Montserrat, sans-serif",
                                                fontSize: "0.85rem",
                                                color: "#374151",
                                                lineHeight: 1.6,
                                                mb: 0.5,
                                            } }, { children: "Ol\u00E1! Escolha um tema para continuar. Voc\u00EA pode clicar em uma das op\u00E7\u00F5es do menu ou digitar o n\u00FAmero correspondente." })), _jsx(Typography, __assign({ sx: {
                                                fontFamily: "Montserrat, sans-serif",
                                                fontSize: "0.7rem",
                                                color: "#9CA3AF",
                                            } }, { children: new Date().toLocaleTimeString("pt-BR", {
                                                hour: "2-digit",
                                                minute: "2-digit",
                                            }) }))] }))), messages.map(function (msg) { return (_jsx(Box, __assign({ sx: {
                                        display: "flex",
                                        justifyContent: msg.role === "user" ? "flex-end" : "flex-start",
                                    } }, { children: _jsxs(Box, __assign({ sx: { maxWidth: "85%" } }, { children: [_jsx(Box, __assign({ sx: __assign({ px: 2, py: 1.2, borderRadius: msg.role === "user"
                                                        ? "14px 14px 4px 14px"
                                                        : "14px 14px 14px 4px" }, (msg.role === "user"
                                                    ? {
                                                        background: "#034EA2",
                                                        color: "#fff",
                                                    }
                                                    : {
                                                        background: "#fff",
                                                        border: "1px solid #ECEEF4",
                                                        color: "#374151",
                                                    })) }, { children: _jsx(Typography, __assign({ sx: {
                                                        fontFamily: "Montserrat, sans-serif",
                                                        fontSize: "0.82rem",
                                                        lineHeight: 1.55,
                                                        whiteSpace: "pre-line",
                                                    } }, { children: formatContent(msg.content) })) })), _jsx(Typography, __assign({ sx: {
                                                    fontFamily: "Montserrat, sans-serif",
                                                    fontSize: "0.65rem",
                                                    color: "#9CA3AF",
                                                    mt: 0.3,
                                                    textAlign: msg.role === "user" ? "right" : "left",
                                                } }, { children: msg.timestamp.toLocaleTimeString("pt-BR", {
                                                    hour: "2-digit",
                                                    minute: "2-digit",
                                                }) }))] })) }), msg.id)); }), isLoading && (_jsx(Box, __assign({ sx: { display: "flex", justifyContent: "flex-start" } }, { children: _jsxs(Box, __assign({ sx: {
                                            px: 2,
                                            py: 1.2,
                                            borderRadius: "14px 14px 14px 4px",
                                            background: "#fff",
                                            border: "1px solid #ECEEF4",
                                            display: "flex",
                                            alignItems: "center",
                                            gap: 1,
                                        } }, { children: [_jsx(CircularProgress, { size: 14, sx: { color: "#034EA2" } }), _jsx(Typography, __assign({ sx: {
                                                    fontFamily: "Montserrat, sans-serif",
                                                    fontSize: "0.8rem",
                                                    color: "#9CA3AF",
                                                } }, { children: "Analisando dados..." }))] })) }))), menuOptions.length > 0 && !isLoading && (_jsxs(Box, __assign({ sx: {
                                        background: "#fff",
                                        borderRadius: "14px",
                                        border: "1px solid #ECEEF4",
                                        p: 1.5,
                                    } }, { children: [_jsx(Typography, __assign({ sx: {
                                                fontFamily: "Montserrat, sans-serif",
                                                fontSize: "0.78rem",
                                                color: "#4B5563",
                                                lineHeight: 1.5,
                                                mb: 1.25,
                                            } }, { children: getMenuDescription(menuState) })), _jsx(Box, __assign({ sx: { display: "flex", flexDirection: "column", gap: 0.8 } }, { children: menuOptions.map(function (option, index) { return (_jsx(Button, __assign({ size: "small", variant: "outlined", onClick: function () { return handleSend(option.label); }, sx: {
                                                    justifyContent: "flex-start",
                                                    textTransform: "none",
                                                    borderRadius: "12px",
                                                    borderColor: "#D1D5DB",
                                                    color: "#374151",
                                                    fontFamily: "Montserrat, sans-serif",
                                                    fontSize: "0.76rem",
                                                    px: 1.25,
                                                    py: 0.9,
                                                    "&:hover": {
                                                        borderColor: "#034EA2",
                                                        background: "rgba(3,78,162,0.04)",
                                                    },
                                                } }, { children: "".concat(index + 1, ". ").concat(option.label) }), "".concat(menuState.kind, "-").concat(option.label))); }) }))] }))), _jsx("div", { ref: messagesEndRef })] })), _jsxs(Box, __assign({ sx: {
                                px: 2,
                                py: 1.5,
                                borderTop: "1px solid #ECEEF4",
                                background: "#fff",
                                flexShrink: 0,
                                display: "flex",
                                gap: 1,
                                alignItems: "flex-end",
                            } }, { children: [_jsx(TextField, { inputRef: inputRef, fullWidth: true, size: "small", value: input, onChange: function (e) { return setInput(e.target.value); }, onKeyDown: function (e) {
                                        if (e.key === "Enter" && !e.shiftKey) {
                                            e.preventDefault();
                                            handleSend();
                                        }
                                    }, placeholder: "Digite o n\u00FAmero da op\u00E7\u00E3o atual", disabled: isLoading, variant: "outlined", sx: {
                                        "& .MuiOutlinedInput-root": {
                                            borderRadius: "12px",
                                            fontFamily: "Montserrat, sans-serif",
                                            fontSize: "0.82rem",
                                            background: "#F9FAFB",
                                            "& fieldset": { borderColor: "#E5E7EB" },
                                            "&:hover fieldset": { borderColor: "#034EA2" },
                                            "&.Mui-focused fieldset": {
                                                borderColor: "#034EA2",
                                                borderWidth: "1.5px",
                                            },
                                        },
                                    } }), _jsx(IconButton, __assign({ onClick: function () { return handleSend(); }, disabled: !input.trim() || isLoading, sx: {
                                        width: 40,
                                        height: 40,
                                        borderRadius: "12px",
                                        background: input.trim() && !isLoading ? "#034EA2" : "#E5E7EB",
                                        color: "#fff",
                                        flexShrink: 0,
                                        "&:hover": { background: "#023B7A" },
                                        "&.Mui-disabled": { color: "#9CA3AF", background: "#E5E7EB" },
                                    } }, { children: _jsx(SendIcon, { sx: { fontSize: 18 } }) }))] }))] })) }))] }));
};
export default AssistentePainel;
